import { useState, useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get } from "@utils/axios_api";

const fetchSiteList = async (params) => {
  const response = await get("/admin/common/siteModalList", { params });
  return response.result;
};

export function useSiteLogic(compCode) {
  const methods = useForm({
    defaultValues: {
      searchCnd: '',
      searchWrd: '',
    },
    shouldFocusError: false, // Focus 방지
  });

  const { handleSubmit, watch } = methods;

  const [committedSearch, setCommittedSearch] = useState({
    searchCnd: "",
    searchWrd: "",
  });

  const [pageIndex, setPageIndex] = useState(1);
  const recordCountPerPage = 5;

  const { searchCnd, searchWrd } = committedSearch;

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["selectSiteModalList", compCode, committedSearch, pageIndex],
    queryFn: () =>
        fetchSiteList({
          compCode,
          searchCnd,
          searchWrd,
          pageIndex,
          recordCountPerPage
        }),
    enabled: !!compCode, // compCode가 있을 때만 쿼리 실행
    keepPreviousData: true,
    staleTime: 600000,
  });

  useEffect(() => {
    if (compCode) {
      refetch();
    }
  }, [pageIndex, compCode, refetch]);

  const onSubmit = (values) => {
    setCommittedSearch({
      searchCnd: values.searchCnd,
      searchWrd: values.searchWrd,
    });
    setPageIndex(1);
  };

  const handlePageChange = (targetPage) => {
    setPageIndex(targetPage);
  };

  return {
    methods,
    handleSubmit,
    watch,
    data,
    isLoading,
    isError,
    error,
    onSubmit,
    handlePageChange,
    pageIndex,
    recordCountPerPage,
  };
}